<script lang="ts" setup>
import FilterActiveCatsSection from '~/components/filters/FilterActiveCatsSection.vue'
import FilterBodyCatsSection from '~/components/filters/FilterBodyCatsSection.vue'
import FilterBrandsSection from '~/components/filters/FilterBrandsSection.vue'
import FilterCategoriesSection from '~/components/filters/FilterCategoriesSection.vue'
import FilterRadioButtonsSection from '~/components/filters/FilterRadioButtonsSection.vue'
// import FilterSidebarCategories from '~/components/filters/FilterSidebarCategories.vue'
import FilterSidebarItem from '~/components/filters/FilterSidebarItem.vue'
import { useSearchboosterStore } from '~/store/searchbooster'

const activeIngredientsFilterToggleStatus = ref(false)
const bodySystemsFilterToggleStatus = ref(false)
const brandsFilterToggleStatus = ref(false)
const catsFilterToggleStatus = ref(true)

const searchboosterStore = useSearchboosterStore()
const { getMaxPrice, getMinPrice, isActiveFilter } = storeToRefs(searchboosterStore)

function onPriceChange (x: any): void {
  searchboosterStore.filter.params.price.max = x.maxValue
  searchboosterStore.filter.params.price.min = x.minValue
}

function resetFilters (): void {
  activeIngredientsFilterToggleStatus.value = false
  bodySystemsFilterToggleStatus.value = false
  brandsFilterToggleStatus.value = false
  catsFilterToggleStatus.value = true

  searchboosterStore.clearFilter()
}
</script>

<template>
  <div
    class="
      custom-scroll
      sticky top-[180px] hidden max-h-[calc(100vh-236px)] min-w-[280px] overflow-y-auto rounded-[20px] bg-white p-5
      md:block
    "
  >
    <div>
      <a
        v-if="isActiveFilter"
        class="absolute right-5 flex items-center !no-underline"
        href="#"
        @click.prevent="resetFilters"
      >
        <SvgIcon class="!size-5 !fill-main-dark" name="outlined/delete" />

        <span class="ml-1 block leading-normal tracking-normal text-main-aluminum">Очистить всё</span>
      </a>

      <FilterSidebarItem title="Категория" :toggle-status="catsFilterToggleStatus">
        <FilterCategoriesSection />
      </FilterSidebarItem>

      <FilterSidebarItem class="mt-6" title="Бренд" :toggle-status="brandsFilterToggleStatus">
        <FilterBrandsSection />
      </FilterSidebarItem>

      <FilterSidebarItem class="mt-6" title="Цена, ₽" toggle-status>
        <RangeSlider
          :from-value="searchboosterStore.filter.params.price.min"
          :max="getMaxPrice ? getMaxPrice : 54900"
          :min="getMinPrice ? getMinPrice : 1"
          :to-value="searchboosterStore.filter.params.price.max"
          @change="onPriceChange"
        />
      </FilterSidebarItem>

      <FilterRadioButtonsSection />

      <FilterSidebarItem class="mt-6" title="Активное вещество" :toggle-status="activeIngredientsFilterToggleStatus">
        <FilterActiveCatsSection />
      </FilterSidebarItem>

      <FilterSidebarItem class="mt-6" title="Система организма" :toggle-status="bodySystemsFilterToggleStatus">
        <FilterBodyCatsSection />
      </FilterSidebarItem>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use 'assets/css/custom-scroll';

.custom-scroll {
  &::-webkit-scrollbar-thumb {
    background: #f1f1f1 !important;
  }

  &:hover::-webkit-scrollbar-thumb {
    background: #f1f1f1 !important;
  }
}
</style>
